import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconJudgeGavel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconJudgeGavel"><Path d="M16.5 2.08594L8.58579 10.0002L12.5 13.9144L15.75 10.6644L20.5 15.4144L21.9142 14.0002L17.1642 9.25015L20.4142 6.00015L16.5 2.08594Z" fill="currentColor"/><Path d="M4 6.58594L2.58579 8.00015L5.5 10.9144L6.91421 9.50015L4 6.58594Z" fill="currentColor"/><Path d="M1 12.0002V14.0002H5V12.0002H1Z" fill="currentColor"/><Path d="M4.27924 16.0002L3.27924 19.0002H2V21.0002H17V19.0002H15.7208L14.7208 16.0002H4.27924Z" fill="currentColor"/></CentralIconBase>;
});

export default IconJudgeGavel;
